import React from "react";
import "./ServicesStrip.scss";

export default class ServicesStrip extends React.Component {
  render() {
    return (
      <div className="services-strip" data-scroll-section>
        <h3>Built for ambitious ideas.</h3>
      </div>
    );
  }
}
